import React, { useState, useMemo } from 'react'
import PropTypes from 'prop-types';
import { Link, useEffect } from 'gatsby'
import { navigate, useLocation } from "@reach/router"


import AudioPlayer from './audioplayer.js';
import BackgroundPhysics from './BackgroundPhysics.js';
import LogPageView from './logpageview.js';
import Blazy from './blazy.min.js';
import Cookies from './cookies.js';

import '../style/yello.scss'



if (typeof(window) !== 'undefined') {
  var bLazyTimer;
  var bLazy = new Blazy();
  window.checkLazyImages = function() {
    if (bLazyTimer) clearTimeout(bLazyTimer);
    bLazyTimer = setTimeout(function() {
      bLazy.revalidate();
    }, 300);
  }
}

var audioPlayer = new AudioPlayer();
audioPlayer.init();

var backgroundPhysics = new BackgroundPhysics();
backgroundPhysics.init(navigate);

var cookieBanner = new Cookies();
cookieBanner.init();



const Template = props => {
  const location = useLocation()
  const [playMode, setPlayMode] = useState(audioPlayer.getPlayMode())

  const toggleSound = () => {
    console.log('toggleSound', playMode)
    switch (playMode) {
      default:
        audioPlayer.setPlayMode('sfx');
        setPlayMode(audioPlayer.getPlayMode());
        break;
      case 'music':
        audioPlayer.setPlayMode('');
        setPlayMode(audioPlayer.getPlayMode());
        break;
      case 'sfx':
        audioPlayer.setPlayMode('music');
        setPlayMode(audioPlayer.getPlayMode());
        break;
    }
  }

  var menuclass = 'mobilemenu';
  if (location.pathname.indexOf('yellology') != -1) menuclass += ' tab2';
  else if (location.pathname.indexOf('discography') != -1) menuclass += ' tab3';
  else if (location.pathname.indexOf('videology') != -1) menuclass += ' tab4';
  else if (location.pathname.indexOf('yellobook') != -1) menuclass += ' tab5';
  else if (location.pathname.indexOf('contact') != -1) menuclass += ' tab6';
  else menuclass += ' tab1';

  if (typeof(window) !== 'undefined') {
    window.checkLazyImages();
  }

  var soundspan = null;
  if (playMode == 'music') soundspan = <span className="value" onClick={() => toggleSound()}>MUSIC</span>;
  else if (playMode == 'sfx') soundspan = <span className="value" onClick={() => toggleSound()}>SFX</span>;
  else soundspan = <span className="value" onClick={() => toggleSound()}>OFF</span>;

  return (
    <div className="page">
      <LogPageView></LogPageView>
      <header>
        <div className="pageheader">
          <div className="inner">
            <div className="logo">
              <div className="y"></div> <Link to={'/'} alt="HOME">
                <b>YELLO.com</b>
                <i>| Hello, and welcome to the Yello site!</i>
              </Link>
            </div>
            <div className="links mobile-only">
              <i onClick={() => toggleSound()}>Sound:</i>
              {soundspan}
              <i></i>
              <span className="imagelinks">
                <a href="https://www.instagram.com/yello_official/" target="_blank"><img src="/img/social-instagram.png" alt="Instagram" /></a>
                <a href="https://www.facebook.com/yello.ch/" target="_blank"><img src="/img/social-facebook.png" alt="Facebook" /></a>
              </span>
            </div>
          </div>
        </div>
        <div className={menuclass}>
          <ul>
            <li className="tab1"><Link to={'/'} alt="NEWS">
              <div className="positive"></div>
              <div className="negative"></div>
              <div className="hint">NEWS</div>
            </Link></li>
            <li className="tab2"><Link to={'/yellology/'} alt="YELLOLOGY">
              <div className="positive"></div>
              <div className="negative"></div>
              <div className="hint">YELLOLOGY</div>
            </Link></li>
            <li className="tab3"><Link to={'/discography/'} alt="DISCOGRAPHY">
              <div className="positive"></div>
              <div className="negative"></div>
              <div className="hint">DISCOG.</div>
            </Link></li>
            <li className="tab4"><Link to={'/videology/'} alt="VIDEOLOGY">
              <div className="positive"></div>
              <div className="negative"></div>
              <div className="hint">VIDEOS</div>
            </Link></li>
            <li className="tab5"><Link to={'/yellobook/'} alt="YELLOBOOK">
              <div className="positive"></div>
              <div className="negative"></div>
              <div className="hint">BOOK</div>
            </Link></li>
            <li className="tab6"><Link to={'/contact/'} alt="CONTACT">
              <div className="positive"></div>
              <div className="negative"></div>
              <div className="hint">CONTACT</div>
            </Link></li>
          </ul>
        </div>
      </header>
      <div className="contentcontainer">
        <div className="inner">
          <div className="contentbox">
            {props.children}
          </div>
        </div>
      </div>
      {props.additional}
    </div>
  )
}

Template.propTypes = {
  children: PropTypes.element,
  additional: PropTypes.element,
}

export default Template
